import { FEATURE_IDS } from '../feature-flag/featureFlags.const'
import { hasFeature } from '../feature-flag/featureFlags.utils'
import type { UserAuthDetail } from '../models/auth/auth.types'
import { AUTH_PRECISIONS, USER_ROLES } from '../models/auth/auth.types'
import { APP_MODES, type AppMode } from './app-mode.types'

export function computeCurrentAppMode(
  currentUserAuthDetail: UserAuthDetail,
): AppMode {
  if (currentUserAuthDetail.role === USER_ROLES.ADVISOR)
    return currentUserAuthDetail.precisions.includes(
      AUTH_PRECISIONS.USER_IS_MINOR,
    )
      ? APP_MODES.MINOR
      : APP_MODES.ADVISOR

  if (currentUserAuthDetail.role === USER_ROLES.ADVISING_REPORT_PDF_GENERATOR)
    return currentUserAuthDetail.precisions.includes(
      AUTH_PRECISIONS.USER_IS_MINOR,
    )
      ? APP_MODES.ADVISING_REPORT_MINOR_PDF_GENERATOR
      : APP_MODES.ADVISING_REPORT_PDF_GENERATOR

  if (currentUserAuthDetail.role === USER_ROLES.SELF_CARE)
    return hasFeature(FEATURE_IDS.shouldDisplaySelfCareV2)
      ? APP_MODES.SELF_CARE_V2
      : APP_MODES.SELF_CARE_V1

  return APP_MODES.NONE
}
